/**
@format
@flow
*/

export type EventNames =
// Onboarding Events
| 'onboarding_create_account'
| 'onboarding_create_account_error'
| 'onboarding_verified_email'
| 'onboarding_verified_email_error'
| 'onboarding_verified_invited_email_error'
| 'onboarding_completed_company_details'
| 'onboarding_completed_company_details_error'
| 'onboarding_create_account_invited'
| 'onboarding_verified_invited_email'
// Company Profile Events
| 'navigated_company_profile'
| 'navigated_edit_company_profile'
| 'navigated_edit_company_profile_videos'
| 'navigated_add_new_question'
| 'navigated_add_new_job_post'
| 'navigated_edit_question'
| 'navigated_content'
| 'navigated_all_jobs'
| 'navigated_edit_job_post'
| 'navigated_create_job_post'
| 'deleted_question'
| 'deleted_job_post_company_profile'
// Personal Information events
| 'navigated_personal_information_settings'
| 'navigated_edit_personal_information'
| 'navigated_change_password'
| 'saved_new_password'
| 'exited_change_password'
| 'saved_new_personal_information'
| 'exited_edit_personal_information'
// EDIT company profile events
| 'opened_photo_modal'
| 'cropped_photo'
| 'changed_photo'
| 'saved_photo'
| 'canceled_crop'
| 'canceled_edit_photo'
| 'exited_edit_company_profile'
| 'saved_company_profile_changes'
// Company Profile Edit Videos
| 'changed_video_title'
| 'edit_video_cancelled'
| 'navigated_change_video'
| 'changed_video_file'
| 'cropped_video'
// Video question events
| 'created_video_question'
| 'added_inspiration_video'
| 'changed_video_question'
| 'played_video'
| 'removed_video_success'
// Content events
| 'archived_question'
| 'unarchive_question'
| 'deleted_question_content'
// Discover
| 'navigated_discover'
| 'navigated_see_all_discover'
| 'added_talent_to_watchlist'
| 'removed_talent_from_watchlist'
| 'viewed_talent_video'
// Filter
| 'navigated_filter'
| 'applied_filters'
| 'reset_filters'
// Watchlist
| 'navigated_watchlist'
| 'emailed_talent'
| 'added_talent_to_watchlist'
| 'removed_talent_from_watchlist'
// Talent Profile
| 'navigated_talent_profile'
| 'talent_profile_add_to_watchlist'
| 'talent_profile_remove_from_watchlist'
| 'talent_profile_email_talent'
| 'talent_profile_copy_talent_phone_number'
| 'viewed_myshot'
| 'viewed_video_response'
// Jobs
| 'archived_job_post'
| 'unarchived_job_post'
| 'deleted_job_post_jobs'
| 'edited_job_post'
| 'created_job_post'
| 'scrolled_through_jobs'
// Originals
| 'navigated_originals_list'
| 'scrolled_through_originals_list'
| 'removed_original_video'
| 'added_original_video'
| 'changed_original_video'
| 'added_original_thumbnail'
| 'changed_original_thumbnail'
| 'removed_original_thumbnail'
// NIL
| 'navigated_nil_list'
| 'scrolled_through_nil_list'
| 'navigated_edit_nil_post'
| 'navigated_add_new_nil_post'
| 'deleted_nil_post'
| 'added_nil_post_thumbnail'
| 'changed_nil_post_thumbnail'
| 'removed_nil_post_thumbnail'
| 'navigated_nil_applications'
| 'scrolled_through_nil_applications'
| 'played_nil_post_application_video';

export const eventNames = {
  // Onboarding Events
  onboarding_create_account: 'onboarding_create_account',
  onboarding_create_account_error: 'onboarding_create_account_error',
  onboarding_verified_email: 'onboarding_verified_email',
  onboarding_verified_email_error: 'onboarding_verified_email_error',
  onboarding_verified_invited_email_error: 'onboarding_verified_invited_email_error',
  onboarding_verified_invited_email: 'onboarding_verified_invited_email',
  onboarding_completed_company_details: 'onboarding_completed_company_details',
  onboarding_completed_company_details_error: 'onboarding_completed_company_details_error',
  onboarding_create_account_invited: 'onboarding_create_account_invited',
  // Company Profile Events
  navigated_company_profile: 'navigated_company_profile',
  navigated_edit_company_profile: 'navigated_edit_company_profile',
  navigated_edit_company_profile_videos: 'navigated_edit_company_profile_videos',
  navigated_content: 'navigated_content',
  navigated_edit_question: 'navigated_edit_question',
  navigated_add_new_question: 'navigated_add_new_question',
  navigated_add_new_job_post: 'navigated_add_new_job_post',
  navigated_all_jobs: 'navigated_all_jobs',
  navigated_edit_job_post: 'navigated_edit_job_post',
  navigated_create_job_post: 'navigated_create_post',
  deleted_question: 'deleted_question',
  deleted_job_post_company_profile: 'deleted_job_post_company_profile',
  // Personal Information events
  navigated_personal_information_settings: 'navigated_personal_information_settings',
  navigated_edit_personal_information: 'navigated_edit_personal_information',
  navigated_change_password: 'navigated_change_password',
  saved_new_password: 'saved_new_password',
  exited_change_password: 'exited_change_password',
  saved_new_personal_information: 'saved_new_personal_information',
  exited_edit_personal_information: 'exited_edit_personal_information',
  // EDIT company profile events
  opened_photo_modal: 'opened_photo_modal',
  changed_photo: 'changed_photo',
  cropped_photo: 'cropped_photo',
  saved_photo: 'saved_photo',
  canceled_crop: 'canceled_crop',
  canceled_edit_photo: 'canceled_edit_photo',
  saved_company_profile_changes: 'saved_company_profile_changes',
  // Compnay Profile Edit Videos
  changed_video_title: 'changed_video_title',
  edit_video_cancelled: 'edit_video_cancelled',
  navigated_change_video: 'navigated_change_video',
  changed_video_file: 'changed_video_file',
  cropped_video: 'cropped_video',
  // Create Video Question
  created_video_question: 'created_video_question',
  added_inspiration_video: 'added_inspiration_video',
  played_video: 'played_video',
  changed_video_question: 'changed_video_question',
  removed_video_success: 'removed_video_success',
  // Content
  archived_question: 'archived_question',
  unarchived_question: 'unarchived_question',
  deleted_question_content: 'deleted_question_content',
  // Discover
  navigated_discover: 'navigated_discover',
  navigated_see_all_discover: 'navigated_see_all_discover',
  viewed_talent_video: 'viewed_talent_video',
  added_talent_to_watchlist: 'added_talent_to_watchlist',
  remove_talent_from_watchlist: 'remove_talent_from_watchlist',
  // Filter
  navigated_filter: 'navigated_filter',
  applied_filters: 'applied_filters',
  reset_filters: 'reset_filters',
  // Watchlist
  navigated_watchlist: 'navigated_watchlist',
  emailed_talent: 'emailed_talent',
  removed_talent_from_watchlist: 'removed_talent_from_watchlist',
  // Talent Profile
  navigated_talent_profile: 'navigated_talent_profile',
  talent_profile_add_to_watchlist: 'talent_profile_add_to_watchlist',
  talent_profile_remove_from_watchlist: 'talent_profile_remove_from_watchlist',
  talent_profile_email_talent: 'talent_profile_email_talent',
  talent_profile_copy_talent_phone_number: 'talent_profile_copy_talent_phone_number',
  viewed_myshot: 'viewed_myshot',
  viewed_video_response: 'viewed_video_response',
  // Jobs
  archived_job_post: 'archived_job_post',
  unarchived_job_post: 'unarchived_job_post',
  deleted_job_post_jobs: 'deleted_job_post_jobs',
  edited_job_post: 'edited_job_post',
  created_job_post: 'created_job_post',
  scrolled_through_jobs: 'scrolled_through_jobs',
  // Originals
  navigated_originals_list: 'navigated_originals_list',
  scrolled_through_originals_list: 'scrolled_through_originals_list',
  removed_original_video: 'removed_original_video',
  added_original_video: 'added_original_video',
  changed_original_video: 'changed_original_video',
  added_original_thumbnail: 'added_original_thumbnail',
  changed_original_thumbnail: 'changed_original_thumbnail',
  removed_original_thumbnail: 'removed_original_thumbnail',
  // NIL
  navigated_nil_list: 'navigated_nil_list',
  scrolled_through_nil_list: 'scrolled_through_nil_list',
  navigated_edit_nil_post: 'navigated_edit_nil_post',
  navigated_add_new_nil_post: 'navigated_add_new_nil_post',
  deleted_nil_post: 'deleted_nil_post',
  added_nil_post_thumbnail: 'added_nil_post_thumbnail',
  changed_nil_post_thumbnail: 'changed_nil_post_thumbnail',
  removed_nil_post_thumbnail: 'removed_nil_post_thumbnail',
  navigated_nil_applications: 'navigated_nil_applications',
  scrolled_through_nil_applications: 'scrolled_through_nil_applications',
  played_nil_post_application_video: 'played_nil_post_application_video',
};
